import { CommandGroup, CommandItem } from "@components/ui/command";
import { Link } from "react-router-dom";
import type { ProviderSearchResult } from "@shared-kernel/application/ports/admin/admin-repository";

interface Props {
  providers: ProviderSearchResult[];
  onSelect: (entityId: string) => void;
  getUrl: (entityId: string) => string;
  onClose: () => void;
}

export const ProviderResultGroup = ({ providers, onSelect, getUrl, onClose }: Props) => {
  if (providers.length === 0) return null;

  return (
    <CommandGroup heading="Prestataires">
      {providers.map(provider => (
        <CommandItem key={provider.entityId} value={provider.entityId} onSelect={() => onSelect(provider.entityId)} className="p-0">
          <Link
            to={getUrl(provider.entityId)}
            className="flex w-full items-center gap-3 px-2 py-1.5"
            onClick={e => {
              if (e.metaKey || e.ctrlKey) {
                e.stopPropagation();
              } else {
                onClose();
              }
            }}
          >
            <span className="flex-1 truncate">{provider.label}</span>
            <span className="ml-auto text-xs text-muted-foreground">{provider.metadata.tag}</span>
          </Link>
        </CommandItem>
      ))}
    </CommandGroup>
  );
};
